import { ISelectItem } from '@lla-platform/core/core-ui'

export enum ChartDataType {
  Sales = 'Sales',
  AvgTicket = 'AvgTicket',
  CarCount = 'CarCount',
  Deferred = 'Deferred'
}

export const ChartDataTypeToLabel: { [key: string]: string } = {
  Sales: 'Sales',
  AvgTicket: 'Average Ticket',
  CarCount: 'Car Count',
  Deferred: 'Deferred'
}

export const ChartDataTypeItems: ISelectItem[] = [
  {
    label: ChartDataTypeToLabel[ChartDataType.Sales],
    value: ChartDataType.Sales
  },
  {
    label: ChartDataTypeToLabel[ChartDataType.AvgTicket],
    value: ChartDataType.AvgTicket
  },
  {
    label: ChartDataTypeToLabel[ChartDataType.CarCount],
    value: ChartDataType.CarCount
  },
  {
    label: ChartDataTypeToLabel[ChartDataType.Deferred],
    value: ChartDataType.Deferred
  }
]
